import type GetKeyboardHeight from './types';

const getKeyboardHeight: GetKeyboardHeight = (height: number) => height;

export default getKeyboardHeight;
